import moment from "moment";
import {
  BaseReq,
  PaginationReq,
  PaginationResp,
  UpdaterResp,
  BaseClass,
  FileRecord,
} from "@/core/interface";
import { getCurrentCompanyId, getCurrentUserId } from "@/utils";

export class SubcontractPaymentPageReq extends PaginationReq {
  supplierCooperationCompanyId: string | undefined = undefined; // 供应商 id
  applyStartDate: string | undefined = undefined; // 签约开始日期
  applyEndDate: string | undefined = undefined; // 签约结束日期
  paymentType: string | undefined = undefined; // 付款类型
  applyTenantUserId: string | undefined = undefined; // 申请人
  // 新增用来收集页面加载时的条件
  contractName:string | undefined = undefined; // 合同名称
  costPaymentStatus:string | undefined = undefined; // 应付款状态
}

export class SubcontractPaymentListRecord extends UpdaterResp {
  id: number = 0; // 分包付款申请Id
  bidNo: string = ""; // 分包付款申请编号
  supplierCooperationCompanyName: string = ""; // 供应商
  subcontractName: string = ""; //付款合同
  applyPaymentAmount: number | undefined = undefined; // 申请付款金额(￥)
  paymentDate: string = ""; // 计划付款日期
  applyDate: string = ""; // 申请日期
  paymentTypeName: string = ""; // 付款类型
  applyTenantUserName: string = ""; // 申请人 name
  validStatus: string = ""; // 生效状态
  validStatusName: string = ""; // 生效状态
  flowStatus: string = ""; // 审批状态Code
  flowStatusName: string = ""; // 审批状态名称
}

export class SubcontractPaymentPageResp extends PaginationResp<SubcontractPaymentListRecord> {}

export class SubcontractPaymentReq extends BaseClass {
  supplierCooperationCompanyId: string | undefined = undefined; // 供应商
  subcontractId: string | undefined = undefined; // 付款合同
  applyDate: string = moment().format("YYYY-MM-DD"); // 申请日期
  applyPaymentAmount: number | undefined = undefined; // 申请付款金额(￥)
  paymentDate: string = moment().format("YYYY-MM-DD"); // 计划付款日期
  paymentType: string | undefined = undefined; // 付款类型
  invoiceTitle: string = ""; // 开户名称
  openingBank: string = ""; // 开户行名称
  openingAccount: string = ""; //   银行账户
  projectId: string | undefined = undefined; // 所属项目 ID
  projectName: string | undefined = undefined; // 所属项目  name
  paymentCooperationCompanyId: string = getCurrentCompanyId(); // 付款单位
  applyTenantUserId: string = getCurrentUserId(); // 申请人 ID
  remark: string = ""; // 备注
  fileList: FileRecord[]; //附件
}

export class SubcontractPaymentResp extends UpdaterResp {
  id: string = "";
  bizNo: string = "";
  supplierCooperationCompanyId: string | undefined = undefined; // 供应商
  supplierCooperationCompanyName: string = ""; // 供应商
  subcontractId: string | undefined = undefined; // 付款合同
  subcontractName: string = ""; // 付款合同
  applyDate: string = moment().format("YYYY-MM-DD"); // 申请日期
  applyPaymentAmount: number | undefined = undefined; // 申请付款金额(￥)
  paymentDate: string = moment().format("YYYY-MM-DD"); // 计划付款日期
  paymentType: undefined = undefined; // 付款类型
  paymentTypeName: string = ""; // 付款类型
  invoiceTitle: string = ""; // 开户名称
  openingBank: string = ""; // 开户行名称
  openingAccount: string = ""; //   银行账户
  projectId: string | undefined = undefined; // 所属项目 ID
  projectName: string | undefined = undefined; // 所属项目  name
  paymentCooperationCompanyId: string | undefined = undefined; // 付款单位
  paymentCooperationCompanyName: string | undefined = undefined; // 付款单位
  applyTenantUserId: string = getCurrentUserId(); // 申请人 ID
  applyTenantUserName: string = getCurrentUserId(); // 申请人 ID
  remark: string = ""; // 备注
  validStatus: string = ""; // 生效状态
  validStatusName: string = ""; // 生效状态
  flowStatus: string = ""; // 审批状态Code
  flowStatusName: string = ""; // 审批状态名称
}

export class SubcontractApplyAmountResp extends BaseReq {
  uuid: number = 1;
  applicationAmount: number = 0; // 本次申请金额
  applicationUnpaidAmount: number = 0; // 已申请未付款金额
  contractAmount: number = 0; // 当前合同金额(￥)
  paidAmount: number = 0; // 已付款金额(￥)
  receivedAmount: number = 0; // 已收票金额(￥)
  settlementAmount: number = 0; // 累计结算金额(￥)
  constructor(amount) {
    super();
    this.applicationAmount = amount;
  }
}

export class SubcontractApplySimpleListReq extends BaseReq {
  subcontractStatus: string = "";
  supplierCooperationCompanyId: string = "";
  addRightBizType:string | undefined = undefined;
}

export class SubcontractApplySimpleRecord {
  id: number = 0;
  name: string = "";
  projectId: string = "";
  projectName: string = "";
  signAmount: number = 0;
  alreadyAppliedAmount: number = 0;
}
